<template>
  <div>
    <div class="soft-card header-soft" v-if="showHeader">
      <div class="nav-soft-row">
        <div class="brand-soft">
          <div class="brand-icon"><i class="fas fa-hand-holding-heart"></i></div>
          <div class="brand-text">益体康 · 心贴智慧工作台</div>
        </div>
        <div class="user-soft" @click.stop="toggleDropdown" v-if="userInfo">
          <div class="user-meta">
            <span><i class="fas fa-user-nurse"></i> {{ userInfo.strUsrRealName || '用户' }}</span>
            <span><i class="fas fa-phone-alt"></i> {{ userInfo.strPhone || '' }}</span>
          </div>
          <div class="avatar-soft">{{ userInfo.strUsrRealName ? userInfo.strUsrRealName.charAt(0) : '用' }}</div>
          <div class="dropdown-menu" :class="{ 'show-dropdown': dropdownVisible }">
            <a @click="handleChangePassword"><i class="fas fa-key"></i> 修改密码</a>
            <a @click="handleLogout"><i class="fas fa-sign-out-alt"></i> 退出登录</a>
          </div>
        </div>
      </div>
      <div class="tabs-soft">
        <div class="tab-soft" :class="{ active: currentTab === 'home' }" @click="navigateTo('/home')">
          <i class="fas fa-chart-pie"></i> 首页
        </div>
        <div class="tab-soft" :class="{ active: currentTab === 'records' }" @click="navigateTo('/recordList')">
          <i class="fas fa-database"></i> 数据记录
        </div>
        <div class="tab-soft" :class="{ active: currentTab === 'projectList' }" @click="navigateTo('/projectList')">
          <i class="fas fa-list-check"></i> 项目列表
        </div>
        <div class="footer-tool">
          <a @click="openDownloadDialog" style="cursor: pointer;">
            <i class="fas fa-download"></i> 报告批量下载工具 v2.8.0
          </a>
        </div>
      </div>
    </div>

    <!-- 修改密码对话框 -->
    <el-dialog
      v-if="showHeader"
      title="修改密码"
      :visible.sync="showChangePasswordDialog"
      width="400px"
      :custom-class="'form-dialog'"
      :close-on-click-modal="false">
      <el-form :model="passwordForm" label-width="80px">
        <el-form-item label="原密码">
          <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleConfirmChangePassword" :disabled="pwdLoading">确定</el-button>
        <el-button @click="handleCancelChangePassword" :disabled="pwdLoading">取消</el-button>
      </span>
    </el-dialog>

    <!-- 下载工具选择弹窗 -->
    <DownloadDialog v-if="showHeader" :show.sync="showDownloadDialog" />
  </div>
</template>

<script>
import ApiService from "../service/ApiService";
import pub from "../service/public";
import cookie from "../service/cookie";
import md5 from "js-md5";
import DownloadDialog from "./DownloadDialog.vue";

export default {
  name: 'AppHeader',
  components: {
    DownloadDialog
  },
  data() {
    return {
      dropdownVisible: false,
      userInfo: {},
      showChangePasswordDialog: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      configVersion: 0,
      showDownloadDialog: false,
      loggingOut: false,
      pwdLoading: false
    }
  },
  computed: {
    currentTab() {
      const path = this.$route.path;
      if (path === '/home') return 'home';
      if (path === '/projectList') return 'projectList';
      if (path === '/recordList') return 'records';
      return 'home';
    },
    showHeader() {
      // 报告分享页（PC端 /pc/report）为对外查看页，不展示内部导航
      return this.$route.path !== '/login' && this.$route.path !== '/pc/report';
    }
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick);
  },
  watch: {
    // 监测路由变化,只要变化了就调用获取路由参数方法将数据存储本组件即可
    $route:{
      handler: function(val, oldVal){
        if(val.path != oldVal.path && val.name != 'Login'){
          this.loadUserInfo();
        }
      },
      deep: true, // 深度观察监听
    }
  },
  created(){
    this.loadUserInfo();

    // 监听配置加载完成事件
    window.addEventListener('configLoaded', () => {
      this.configVersion++;
    });
  },
  methods: {
    loadUserInfo() {
      let userInfoStr = cookie.getCookie('28project_UsrInfo');
      if(userInfoStr){
        this.userInfo = JSON.parse(userInfoStr);
        this.userInfo.strPhone = this.$cookies.get('28project_username');
      }

    },
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible;
    },
    handleDocumentClick(e) {
      if (!e.target.closest('.user-soft')) {
        this.dropdownVisible = false;
      }
    },
    navigateTo(path) {
      this.$router.push(path);
    },
    handleLogout() {
      if (this.loggingOut) return
      this.loggingOut = true
      this.dropdownVisible = false;

      // 从本地存储中获取当前登录用户信息
      let accountInfoStr = cookie.getCookie('28project_UsrInfo');
      let accountInfo = accountInfoStr ? JSON.parse(accountInfoStr) : {};

      let requestParams = {
        page: {
          number: 0,
          Limit: 1
        },
        keyWord: [],
        parms: {
          strClientUuid: 'A0F9GQHU6YE3D5AG',
          strUsrUuid: accountInfo.strUsrUUID
        }
      };

      ApiService.UsrLogout(requestParams).then((returnDa) => {
        // 无论接口调用成功与否，都清除本地数据并跳转到登录页
        cookie.removeCookie('28project_UsrInfo');
        localStorage.removeItem('28project_config'); // 清除配置
        // 清登录态：cookie 与 localStorage 双清（localStorage 为权威源，仅清 cookie 会导致未真正退出）
        pub.clearLoginState();
        this.$cookies.remove('28project_usertoken');
        this.$cookies.remove('28project_refreshToken');
        // 保留用户名和密码的cookie，以便下次登录自动填充
        this.$router.replace('/login');
      })
      .catch((error) => {
        console.error('退出登录失败：', error);
        // 即使接口调用失败，也清除本地数据并跳转到登录页
        cookie.removeCookie('28project_UsrInfo');
        localStorage.removeItem('28project_config'); // 清除配置
        // 清登录态：cookie 与 localStorage 双清（localStorage 为权威源，仅清 cookie 会导致未真正退出）
        pub.clearLoginState();
        this.$cookies.remove('28project_usertoken');
        this.$cookies.remove('28project_refreshToken');
        // 保留用户名和密码的cookie，以便下次登录自动填充
        this.$router.replace('/login');
      })
      .finally(() => {
        this.loggingOut = false
      });
    },
    handleChangePassword() {
      this.dropdownVisible = false;
      this.showChangePasswordDialog = true;
    },
    openDownloadDialog() {
      this.showDownloadDialog = true;
    },
    handleCancelChangePassword() {
      this.showChangePasswordDialog = false;
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
    },
    handleConfirmChangePassword() {
      if (this.pwdLoading) return
      if (!this.passwordForm.oldPassword || !this.passwordForm.newPassword || !this.passwordForm.confirmPassword) {
        this.$message.warning('请填写完整信息');
        return;
      }
      if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
        this.$message.warning('两次输入的密码不一致');
        return;
      }

      // 从本地存储中获取当前登录用户信息
      let accountInfoStr = cookie.getCookie('28project_UsrInfo');
      let accountInfo = accountInfoStr ? JSON.parse(accountInfoStr) : {};

      let requestParams = {
        page: {
          number: 0,
          Limit: 1
        },
        keyWord: [],
        parms: {
          strClientUuid: 'A0F9GQHU6YE3D5AG',
          strUsrUuid: accountInfo.strUsrUUID,
          strUsrPwd: md5(this.passwordForm.oldPassword.trim()),
          strUsrName: this.$cookies.get('28project_username'),
          strUsrNewPwd: md5(this.passwordForm.newPassword.trim())
        }
      };

      this.pwdLoading = true
      ApiService.UsrUpdPwd(requestParams).then((returnDa) => {
        if (returnDa.code === pub.backCode.SUCCESS) {
          // 清登录态：cookie 与 localStorage 双清（localStorage 为权威源，否则改密后仍能凭 localStorage 令牌保持登录）
          pub.clearLoginState();
          cookie.removeCookie('28project_UsrInfo');
          localStorage.removeItem('28project_UsrInfo');
          this.$cookies.set('28project_userpwd', this.passwordForm.newPassword);
          this.$message.success('修改成功，请重新登录！');
          this.handleCancelChangePassword();
          setTimeout(() => {
            this.$router.push('/login');
          }, 1000);
        } else {
          pub.analysisReturnCode(returnDa, null);
        }
      })
      .catch((error) => {
        console.error('修改密码失败：', error);
        this.$message.error('修改密码失败');
      })
      .finally(() => {
        this.pwdLoading = false
      });
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue